interface ReviewCardProps {
  name: string;
  avatar: string;
  role: string;
  rating: number;
  content: string;
  isLast?: boolean;
}

export default function ReviewCard({ name, avatar, role, rating, content, isLast }: ReviewCardProps) {
  return (
    <div className="bg-background-50 rounded-2xl p-6 border border-background-200/70">
      <div className="flex items-center gap-1 mb-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <i
            key={i}
            className={`text-sm ${i < rating ? "ri-star-fill text-amber-500" : "ri-star-line text-foreground-300"}`}
          ></i>
        ))}
      </div>
      <h4 className="text-sm font-semibold text-foreground-950 mb-2">
        {rating === 5 ? "每天都在追！" : rating === 4 ? "非常推荐" : "还不错"}
      </h4>
      <p className={`text-sm leading-relaxed mb-4 ${isLast ? "text-foreground-300" : "text-foreground-600"}`}>
        {content}
      </p>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
          <img src={avatar} alt={name} className="w-full h-full object-cover" loading="lazy" />
        </div>
        <div>
          <p className="text-sm font-semibold text-foreground-950">{name}</p>
          <p className="text-xs text-foreground-500">{role}</p>
        </div>
      </div>
    </div>
  );
}